import { BasicInput, ModalComponent } from "Common/Components";
import Modal from "Common/Components/Modal";
import { useModalAddSpecialPermissions } from "feature/specialpermissions/hooks";
import { useSpecialPermissionStore } from "feature/specialpermissions/store";

export const ModalAddSpecialPermission = () => {
  const { isOpenModal, setIsOpenModal, clearAll, isEdit } =
    useSpecialPermissionStore();
  const { formik, t } = useModalAddSpecialPermissions();

  return (
    <ModalComponent
      modalTitle={
        isEdit
          ? t("SpecialPermission.titleModal.edit")
          : t("SpecialPermission.titleModal.create")
      }
      show={isOpenModal}
      onHide={() => {
        setIsOpenModal(false);
        clearAll();
        formik.resetForm();
      }}
      size="md"
    >
      <form
        className="mt-8"
        id="signInForm"
        onSubmit={(event) => {
          event.preventDefault();
          formik.handleSubmit();
          return false;
        }}
      >
        <BasicInput
          label={t("SpecialPermission.label.description")}
          placeholder={t("SpecialPermission.placeholders.description")}
          id="description"
          name="description"
          type="text"
          value={formik.values.description}
          isError={!!(formik.touched.description && formik.errors.description)}
          errorMessage={formik.errors.description || ""}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <div className="mt-10">
          <button
            type="submit"
            disabled={formik.isSubmitting}
            className="w-full flex flex-row justify-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            {isEdit
              ? t("SpecialPermission.buttons.edit")
              : t("SpecialPermission.buttons.addbtn")}
          </button>
        </div>
      </form>
    </ModalComponent>
  );
};
